import axios from "axios";
export default {
  namespaced: true,
  state: {
    items: [],
    all_items: [],
    returned_items: [],
    item_orders: [],
    item_order_for_add: null,
    stock_lots: [],
    warranty_alerts: [],
    price_history: [],
    item_serials: [],
  },
  getters: {
    item_order_for_add(state) {
      return state.item_order_for_add;
    },
    items(state) {
      return state.items;
    },
    all_items(state) {
      return state.all_items;
    },
    returned_items(state) {
      return state.returned_items;
    },
    item_orders(state) {
      return state.item_orders;
    },
    stock_lots(state) {
      return state.stock_lots;
    },
    warranty_alerts(state) {
      return state.warranty_alerts;
    },
    price_history(state) {
      return state.price_history;
    },
    item_serials(state) {
      return state.item_serials;
    },
  },
  mutations: {
    DELETE_ITEM_ORDER(state, item_order_id) {
      let filtered = state.items.filter((c) => {
        return c.id != item_order_id;
      });
      state.items = filtered;
    },
    SET_ITEM_ORDER_FOR_ADD(state, item) {
      state.item_order_for_add = item;
    },
    // ITEM ORDERS
    SET_ITEM_ORDERS(state, items) {
      state.item_orders = items;
    },
    ADD_ITEM_ORDER(state, item) {
      state.item_orders.unshift(item);
    },
    EDIT_ITEM_ORDER(state, item) {
      var index = state.item_orders.findIndex((a) => a.id == item.id);
      state.item_orders.splice(index, 1, item);
    },

    // RETURNED ITEM
    EDIT_RETURNED_ITEM(state, item) {
      var index = state.returned_items.findIndex((a) => a.id == item.id);
      state.returned_items.splice(index, 1, item);
    },
    DELETE_RETURNED_ITEM(state, item_id) {
      let filtered = state.returned_items.filter((c) => {
        return c.id != item_id;
      });
      state.returned_items = filtered;
    },
    RESTORE_ITEM(state, item) {
      // remove from all items
      let filtered_all_items = state.all_items.filter((c) => {
        return c.id != item.id;
      });
      state.all_items = filtered_all_items;

      // add to items
      state.items.unshift(item);
    },
    FORCE_DELETE_ITEM(state, item_id) {
      state.all_items = state.all_items.filter((c) => c.id != item_id);
      state.items = state.items.filter((c) => c.id != item_id);
    },
    SET_RETURNED_ITEMS(state, returned_items) {
      state.returned_items = returned_items;
    },
    ADD_RETURNED_ITEM(state, item) {
      state.returned_items.unshift(item);
    },
    SET_ITEMS(state, items) {
      state.items = items;
    },
    SET_ALL_ITEMS(state, all_items) {
      state.all_items = all_items;
    },
    ADD_ITEM(state, item) {
      state.items.unshift(item);
    },
    EDIT_ITEM(state, item) {
      var index = state.items.findIndex((a) => a.id == item.id);
      state.items.splice(index, 1, item);
    },
    DELETE_ITEM(state, item_id) {
      let filtered = state.items.filter((c) => {
        return c.id != item_id;
      });
      state.items = filtered;
    },
    BULK_DELETE_ITEMS(state, item_ids) {
      state.items = state.items.filter((c) => !item_ids.includes(c.id));
    },
    SET_STOCK_LOTS(state, lots) {
      state.stock_lots = lots;
    },
    SET_WARRANTY_ALERTS(state, alerts) {
      state.warranty_alerts = alerts;
    },
    SET_PRICE_HISTORY(state, history) {
      state.price_history = history;
    },
    SET_ITEM_SERIALS(state, serials) {
      state.item_serials = serials;
    },
    EDIT_ITEM_SERIAL(state, serial) {
      var index = state.item_serials.findIndex((a) => a.id == serial.id);
      state.item_serials.splice(index, 1, serial);
    },
    DELETE_ITEM_SERIAL(state, serial_id) {
      state.item_serials = state.item_serials.filter((s) => s.id != serial_id);
    },
  },
  actions: {
    async delete_item_order({ commit }, item_order_id) {
      await axios.delete("/item_order/" + item_order_id);
      commit("DELETE_ITEM_ORDER", item_order_id);
    },
    set_item_order_for_add({ commit }, request) {
      commit("SET_ITEM_ORDER_FOR_ADD", request);
    },
    // ITEM ORDERS
    async add_item_order({ commit }, request) {
      let response = await axios.post("/item_order", request);
      commit("ADD_ITEM_ORDER", response.data);
    },
    async get_item_orders({ commit }, request) {
      let response = await axios.get("/item_orders", request);
      commit("SET_ITEM_ORDERS", response.data);
    },
    async edit_item_order({ commit }, item) {
      await axios.put("/item_order", item);
      commit("EDIT_ITEM_ORDER", item);
    },
    // RETURNED ITEMS
    async edit_returned_item({ commit, rootGetters }, item) {
      let response = await axios.put("/returned_item", {
        ...item,
        updated_by: rootGetters["auth/user"]?.full_name,
      });
      commit("EDIT_RETURNED_ITEM", response.data);
    },
    async delete_returned_item({ commit }, item_id) {
      await axios.delete("/returned_item/" + item_id);
      commit("DELETE_RETURNED_ITEM", item_id);
    },

    async restore_item({ commit }, request) {
      let response = await axios.post("/restore_item", request);
      commit("RESTORE_ITEM", response.data);
    },
    async force_delete_item({ commit }, item_id) {
      await axios.delete(`/item/${item_id}/force_delete`);
      commit("FORCE_DELETE_ITEM", item_id);
    },
    async get_returned_items({ commit }) {
      let response = await axios.get("/returned_items");
      // console.log(response.data);
      commit("SET_RETURNED_ITEMS", response.data);
    },
    async add_returned_item({ commit }, request) {
      let response = await axios.post("/returned_item", request);
      commit("ADD_RETURNED_ITEM", response.data);
    },
    async get_items({ commit }) {
      let response = await axios.get("/items");
      commit("SET_ITEMS", response.data);
    },
    async get_all_items({ commit }, params) {
      let response = await axios.get("/all_items", { params });
      commit("SET_ALL_ITEMS", response.data);
    },
    async get_items_from_branch(_, branchId) {
      let response = await axios.get("/items", {
        params: { branch_id: branchId },
      });
      return response.data;
    },
    async add_item({ commit }, request) {
      let response = await axios.post("/item", request);
      if (request.modal_from != "item transfer")
        commit("ADD_ITEM", response.data);
      return response.data;
    },
    async edit_item({ commit }, request) {
      let response = await axios.put("/item", request);
      commit("EDIT_ITEM", response.data);
      return response.data;
    },
    async add_stock({ commit }, request) {
      let response = await axios.post("/add_stock", request);
      commit("EDIT_ITEM", response.data);
    },
    async delete_item({ commit }, item_id) {
      await axios.delete("/item/" + item_id);
      commit("DELETE_ITEM", item_id);
    },
    async bulk_delete_items({ commit }, item_ids) {
      await axios.post("/items/bulk_delete", { item_ids });
      commit("BULK_DELETE_ITEMS", item_ids);
    },
    edit({ commit }, item) {
      commit("EDIT_ITEM", item);
    },
    // FIFO Stock Lots
    async restock_item({ commit }, { itemId, payload }) {
      let response = await axios.post(`/item/${itemId}/restock`, payload);
      commit("EDIT_ITEM", response.data.item);
      return response.data;
    },
    async get_stock_lots({ commit }, itemId) {
      let response = await axios.get(`/item/${itemId}/stock_lots`);
      commit("SET_STOCK_LOTS", response.data);
      return response.data;
    },
    // RMA Lifecycle
    // Accepts either a bare returned-item id (same-item replacement) or a payload
    // { id, replacement_item_id, replacement_quantity } for a substitute item.
    async give_replacement({ commit, rootGetters }, payload) {
      const id = typeof payload === "object" ? payload.id : payload;
      const updated_by = rootGetters["auth/user"]?.full_name;
      const body =
        typeof payload === "object"
          ? {
              replacement_item_id: payload.replacement_item_id,
              replacement_quantity: payload.replacement_quantity,
              updated_by,
            }
          : { updated_by };
      let response = await axios.put(
        `/returned_item/${id}/give_replacement`,
        body
      );
      commit("EDIT_RETURNED_ITEM", response.data);
      return response.data;
    },
    async mark_supplier_return({ commit, rootGetters }, returnedItemId) {
      let response = await axios.put(
        `/returned_item/${returnedItemId}/mark_supplier_return`,
        { updated_by: rootGetters["auth/user"]?.full_name }
      );
      commit("EDIT_RETURNED_ITEM", response.data);
      return response.data;
    },
    async return_to_supplier({ commit, rootGetters }, { id, date_returned }) {
      let response = await axios.put(
        `/returned_item/${id}/return_to_supplier`,
        { date_returned, updated_by: rootGetters["auth/user"]?.full_name }
      );
      commit("EDIT_RETURNED_ITEM", response.data);
      return response.data;
    },
    // Accepts either a bare returned-item id (replacement lot goes to the original
    // item) or a payload { id, replacement_target_item_id } to direct the new
    // stock lot into a specific active item record.
    async supplier_replaced({ commit, rootGetters }, payload) {
      const id = typeof payload === "object" ? payload.id : payload;
      let response = await axios.put(`/returned_item/${id}/supplier_replaced`, {
        replacement_target_item_id:
          typeof payload === "object"
            ? payload.replacement_target_item_id
            : null,
        updated_by: rootGetters["auth/user"]?.full_name,
      });
      commit("EDIT_RETURNED_ITEM", response.data);
      return response.data;
    },
    async supplier_credited({ commit, rootGetters }, { id, credit_amount }) {
      let response = await axios.put(`/returned_item/${id}/supplier_credited`, {
        credit_amount,
        updated_by: rootGetters["auth/user"]?.full_name,
      });
      commit("EDIT_RETURNED_ITEM", response.data);
      return response.data;
    },
    async supplier_write_off({ commit, rootGetters }, returnedItemId) {
      let response = await axios.put(
        `/returned_item/${returnedItemId}/supplier_write_off`,
        { updated_by: rootGetters["auth/user"]?.full_name }
      );
      commit("EDIT_RETURNED_ITEM", response.data);
      return response.data;
    },
    async merge_items({ commit }, { target_item_id, source_item_id }) {
      let response = await axios.post("/items/merge", {
        target_item_id,
        source_item_id,
      });
      commit("EDIT_ITEM", response.data.item);
      commit("DELETE_ITEM", source_item_id);
      return response.data;
    },
    async get_invoice_lot_deductions(_, invoiceId) {
      let response = await axios.get(`/invoice/${invoiceId}/lot_deductions`);
      return response.data;
    },
    // Warranty
    async get_warranty_alerts({ commit }, { branchId, days }) {
      let response = await axios.get(`/items/warranty_alerts`, {
        params: { branch_id: branchId, days: days || 90 },
      });
      commit("SET_WARRANTY_ALERTS", response.data);
      return response.data;
    },
    async update_stock_lot(_, { lotId, payload }) {
      let response = await axios.put(`/item_stock_lot/${lotId}`, payload);
      return response.data;
    },
    async update_lot_warranty(
      _,
      { lotId, supplier_warranty_months, supplier_warranty_unit }
    ) {
      let response = await axios.put(`/item_stock_lot/${lotId}/warranty`, {
        supplier_warranty_months,
        supplier_warranty_unit: supplier_warranty_unit || "months",
      });
      return response.data;
    },
    // Serial Numbers (JMB-238)
    async get_item_serials({ commit }, itemId) {
      let response = await axios.get(`/item/${itemId}/serials`);
      commit("SET_ITEM_SERIALS", response.data);
      return response.data;
    },
    async add_item_serials({ commit }, { itemId, payload }) {
      let response = await axios.post(`/item/${itemId}/serials`, payload);
      commit("SET_ITEM_SERIALS", response.data);
      return response.data;
    },
    async set_item_serialized({ commit, state }, { itemId, is_serialized }) {
      let response = await axios.put(`/item/${itemId}/serialized`, {
        is_serialized,
      });
      const item = state.items.find((i) => i.id == itemId);
      if (item) {
        commit("EDIT_ITEM", {
          ...item,
          is_serialized: response.data.is_serialized,
        });
      }
      return response.data;
    },
    async update_item_serial({ commit }, { serialId, payload }) {
      let response = await axios.put(`/item_serial/${serialId}`, payload);
      commit("EDIT_ITEM_SERIAL", response.data);
      return response.data;
    },
    async delete_item_serial({ commit }, serialId) {
      await axios.delete(`/item_serial/${serialId}`);
      commit("DELETE_ITEM_SERIAL", serialId);
    },
    // Price History
    async get_price_history({ commit }, itemId) {
      let response = await axios.get(`/item/${itemId}/price_history`);
      commit("SET_PRICE_HISTORY", response.data);
      return response.data;
    },
    // Category Price Adjustment
    async category_price_adjustment_preview(_, payload) {
      let response = await axios.post(
        "/items/category_price_adjustment/preview",
        payload
      );
      return response.data;
    },
    async category_price_adjustment({ dispatch }, payload) {
      let response = await axios.post(
        "/items/category_price_adjustment",
        payload
      );
      // Refresh items list after adjustment
      await dispatch("get_items");
      return response.data;
    },
  },
};
